










import Vue from "vue";
import Component from "vue-class-component";
import Navbar from "./navbar.vue";
import Footer from './footer.vue';

@Component({
  components: {
    navbar: Navbar,
    footerbar: Footer,
  }
})
export default class Layout extends Vue {
 
}
